import { connect } from 'react-redux'
import { compose } from 'redux'
import getData from '../functions/getData'
import { PROGRAM_CLI_MOVIES_ITEMS } from '../constants/state'

const mapStateToProps = (state, ownProps) => ({
    movieData: getData(state, [PROGRAM_CLI_MOVIES_ITEMS, ownProps.movieId])
})

const hasSingleMovie = () => WrappedComponent => {
    const HasSingleMovie = props => <WrappedComponent {...props} />

    return compose(
        connect(mapStateToProps, null)
    )(HasSingleMovie)
}

export default hasSingleMovie